<template>
  <div v-loading="loading">
    <div class="card card-custom card-stretch gutter-b">
      <div class="card-header">
        <div class="card-title">
          <span class="card-icon">
            <i class="flaticon2-delivery-package text-primary"></i>
          </span>
          <h3 class="card-label"><b class="title-header">{{ BusinessTitle }}</b></h3>
        </div>
      </div>

      <div class="card-body">
        <div class="text-right mb-4" v-if="data.status == 1">
          <button @click="$router.push({ name: 'budget-pre-actual-report' })"
            v-if="(currentUser.super_user == 1)"
            class="btn btn-secondary mr-2">予実レポート
          </button>
          <button @click="$router.push({ name: 'budget-report', params: { answer_id: id_answer } })"
            class="btn btn-secondary mr-2">予算
          </button>
          <button @click="$router.push({ name: 'performance-report', params: { answer_id: id_answer } })"
            class="btn btn-secondary mr-2">実績
          </button>
          <button @click="$router.push({ name: 'annual-voucher', params: { answer_id: id_answer } })"
            class="btn btn-secondary mr-2">年次証憑
          </button>
          <button @click="$router.push({ name: 'weekly-voucher', params: { answer_id: id_answer } })"
            class="btn btn-secondary mr-2">月次証憑
          </button>
          <button @click="$router.push({ name: 'detail-voucher-custom', params: { id_answer: id_answer } })"
            class="btn btn-secondary mr-2">その他証憑
          </button>
        </div>
          <reject-comment :formAnserDetail="data"></reject-comment>
<!--          <div class="admin-comment mb-5" v-if="Object.keys(this.data).length !== 0 && Object.keys(this.data.reject_reason).length > 0">-->
<!--              <table class="table rounded table-top">-->
<!--                  <thead class="thead-dark text-center">-->
<!--                  <tr>-->
<!--                      <th class="w-25 text-center">差し戻し日時</th>-->
<!--                      <th class="w-75 text-center">差し戻しコメント</th>-->
<!--                  </tr>-->
<!--                  </thead>-->
<!--                  <tbody>-->
<!--                  <tr v-for="(reject_reason, index_reject_reason) in data.reject_reason" :key="index_reject_reason">-->
<!--                      <th class="w-25 text-center">{{ reject_reason.created_at_xx }}</th>-->
<!--                      <th class="w-75 text-center text-break">{{ reject_reason.comment }}</th>-->
<!--                  </tr>-->
<!--                  </tbody>-->
<!--              </table>-->
<!--          </div>-->
        <table class="table rounded table-top mt-4">
          <thead class="thead-dark text-center">
            <tr>
              <th>項目</th>
              <th>内容</th>
            </tr>
          </thead>
          <tbody  v-if="Object.keys(this.data).length !== 0">
            <tr>
              <th>会社名</th>
              <th>{{ data.company_name }}</th>
            </tr>
            <tr>
              <th>表示名</th>
              <th>{{ data.display_name }}</th>
            </tr>
            <tr>
              <th>代表者名</th>
              <th>{{ data.representative_name }}</th>
            </tr>
            <tr>
              <th>住所</th>
              <th>{{ data.address }}</th>
            </tr>
            <tr>
              <th>代表TEL</th>
              <th>{{ data.tel }}</th>
            </tr>
            <tr>
              <th>再委託選定方法</th>
              <th>{{ data.subcontract_method }}</th>
            </tr>
            <tr>
              <th>再委託理由</th>
              <th>{{ data.reason_subcontracting }}</th>
            </tr>
            <tr>
              <th>上位委託先</th>
              <th>{{ data.superior_contractor }}</th>
            </tr>
            <tr>
              <th>担当者名</th>
              <th>{{ data.name_of_person_charge }}</th>
            </tr>
            <tr>
              <th>担当者TEL</th>
              <th>{{ data.tel_of_person_charge }}</th>
            </tr>
            <tr>
              <th>担当者Mail</th>
              <th>{{ data.email }}</th>
            </tr>
            <tr>
              <th>契約日</th>
              <th v-if="data.contract_date">{{ convertDate(data.contract_date) }}</th>
            </tr>
            <tr>
              <th>契約終了予定日</th>
              <th v-if="data.contract_end_date">{{ convertDate(data.contract_end_date)}}</th>
            </tr>
            <tr>
              <th>契約額</th>
              <th v-if="data.contract_amount">{{formatter(data.contract_amount)}}</th>
            </tr>
            <tr>
              <th>契約内容</th>
              <th>{{ data.contract_details }}</th>
            </tr>
            <tr>
              <th>契約方法</th>
              <th>{{ data.contract_method }}</th>
            </tr>
            <tr>
              <th>変更契約有無</th>
              <th>{{ data.contract_change }}</th>
            </tr>
            <tr>
              <th>再委託有無</th>
              <th>{{ data.contract_commission }}</th>
            </tr>
            <tr>
              <th>その他</th>
              <th>{{ data.other }}</th>
            </tr>
            <tr>
              <th>予算額</th>
              <th>{{ formatter(data.form2_price) }}</th>
            </tr>
            <tr>
              <th>実績額</th>
              <th>{{ formatter(data.form3_price) }}</th>
            </tr>
            <tr>
              <th>予算消化率</th>
              <th>{{ data.verage_price }}</th>
            </tr>
            <tr>
              <th>委託先区分</th>
              <th>
                <el-form class="form-base">
                  <el-select v-model="data.category">
                    <el-option
                      v-for="item in category_options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    > 
                    </el-option>
                  </el-select>
                  <input type="hidden" name="_csrf" v-model="data._csrf" />
              </el-form>
              </th>
            </tr>
          </tbody>
            <tbody v-else>
            <div class="el-table__empty-block show_err_data_null">
                <span class="el-table__empty-text"> 検索結果がありません。条件を変更して再度検索してください。</span>
            </div>
            </tbody>
        </table>
        <div class="text-center">
          <span>
            <button v-if="approval" @click="changeStatus(1)" class="btn btn-secondary mr-4">承認
            </button>
            <button v-if="denial" @click="changeStatus(2)" class="btn btn-secondary mr-4">否認
            </button>
          </span>
          <button v-if="sendBack" @click="changeStatus(3)" class="btn btn-secondary mr-4">差し戻し
          </button>
          <button @click="updateForm()" class="btn btn-secondary">更新
          </button>
        </div>
      </div>
    </div>

    <el-dialog
      :lock-scroll="false"
      :visible.sync="dialog.dialog"
      width="50%"
      class="content_popup"
      :show-close="false"
      center>
        <div class="textwidget text-center">
            {{ dialog.headerText }}理由を入力してください
        </div>

        <el-input class="mt-10" type="textarea" :rows="3" placeholder="入力してください" v-model="dialog.reason"></el-input>

        <span slot="footer" class="dialog-footer">
          <el-button :disabled="dialog.reason.length == 0" class="btn_submit_dialog" @click="setStatus(dialog.status)">処理確定</el-button>
        </span>
    </el-dialog>

  </div>
</template>

<script>
import apiService from "@/core/services/api.service";
import { mapActions, mapGetters } from 'vuex';
import { GET_DETAIL_ANSWER } from "@/core/services/store/formAnswer.module";
import { SET_TITLE_BUSINESS } from "@/core/services/store/business.module";
import { SUCCESS_MESSAGE } from "@/core/config/constant";
import moment from 'moment'
import { getCsrfRandom } from "@/core/services/store/auth.module";

export default {
  data() {
    return {
      loading: false,
      data: {},
      id_answer: '',
      approval: false,
      denial: false,
      sendBack: false,
      dialog: {
        dialog: false,
        status: null,
        headerText: '',
        reason: ''
      },
      category_options: [
        {
          value: 1,
          label: '委託先'
        },
        {
          value: 2,
          label: '外注先'
        }
      ]
    };
  },
  async created() {
    this.loading = true;
    this.id_answer = this.$route.params.id
    await this.getDetailAnswer({ id: this.id_answer })
    if (this.BusinessTitle == null) {
      await this.setTitleBusiness()
    }
    this.data = this.detailAnswer
    this.data._csrf = getCsrfRandom()
    if (this.data.status != 3 && this.data.status != 2) {
    if (this.data.is_view_list_approval) {
      if (this.data.is_approval) {
        if (this.data.status == 0) {
          this.sendBack = true
          this.denial = true
          this.approval = true
        }
        if (this.data.status == 1) {
          if (!this.data.status != 2 || !this.data.status != 3) {
            this.sendBack = true
          }
        }
      } else {
        this.sendBack = true
      }
    }
    }

    if (Object.keys(this.data).length === 0) {
      this.$router.push({ name: 'subcontractor' })
    }
    this.loading = false;
  },
  computed: {
    ...mapGetters(["detailAnswer", "BusinessTitle", "currentUser"]),
  },
  watch: {
    "dialog.dialog"() {
      if (this.dialog.dialog == false) {
        this.dialog.reason = ''
      }
    }
  },
  methods: {
    ...mapActions([GET_DETAIL_ANSWER, SET_TITLE_BUSINESS]),
    async changeStatus(status) {
      if (status == 2 || status == 3) {
        this.dialog.status = status
        this.dialog.headerText = status == 2 ? '否認' : '差し戻し'
        this.dialog.dialog = true
      }
      if (status == 1) {
        this.setStatus(1)
      }
    },
    async updateForm() {
      this.loading = true
      const payload = {
        category:  this.data.category
      }
      await apiService.post(`form/update-answer-detail/${this.id_answer}`, payload).then(async (data) => {
        if (data && data.data && data.data.success) { 
          this.notifySuccess(SUCCESS_MESSAGE)
        } else {
          if (data.data.code == 403 || data.data.code == 422) {
            this.notifyError(data.data.data)
          } else {
            this.notifyError('error server')
          }
        }
      })
      .catch(e => {
        this.notifyError(e)
        this.loading = false
      })
      this.loading = false
    },
    async setStatus(status) {
      this.loading = true

      apiService.post(`form/approval-answer/${this.id_answer}/${status}`, {reject_reason: this.dialog.reason}).then(async (data) => {
        if (data && data.data && data.data.success) {
          await this.getDetailAnswer({ id: this.id_answer })
          this.data = this.detailAnswer
          this.sendBack = false
          this.denial = false
          this.approval = false
          if (this.data.status != 3 && this.data.status != 2) {
          if (this.data.is_view_list_approval) {
            if (this.data.is_approval) {
              if (this.data.status == 0) {
                this.sendBack = true
                this.denial = true
                this.approval = true
              }
              if (this.data.status == 1) {
                if (!this.data.status != 2 || !this.data.status != 3) {
                  this.sendBack = true
                }
              }
            } else {
              if ([0, 1].includes(this.data.status)) {
                this.sendBack = true
              }
            }
          }
          }
          this.notifySuccess(SUCCESS_MESSAGE)
          this.dialog.dialog = false
        } else {
          if (data.data.code == 403 || data.data.code == 422) {
            this.notifyError(data.data.data)
          } else {
            this.notifyError('error server')
          }
        }
      })
        .catch(e => {
          this.notifyError(e)
          this.loading = false

        })

      this.loading = false
    },
    convertDate(date) {
      let data;
      if (date) {
        data = moment(date).format('YYYY/MM/DD')
      }
      return data;
    },
    formatter(unformated_cost) {
      let formatter = unformated_cost;
      if (unformated_cost && !(/[^0-9]/g).test(unformated_cost)) {
        const cost = BigInt(unformated_cost)
        formatter = new Intl.NumberFormat('ja-JP', { currency: "JPY" }).format(cost)
      }
      return formatter
    },
  }
}
</script>

<style scoped>
.table-top,
.table-top th,
.table-top td {
  border: 1px solid #EBEDF3;
  border-collapse: collapse;
}
.show_err_data_null {
    height: 100%;
    width: 1529px;
}
</style>
